import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { Switch } from 'react-router-dom';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

const importGettingStartedRoutes = () => import(/* webpackChunkName: "getting-started-main" */ './containers/GettingStartedContainer');
const importLearnAutomationRoutes = () => import(/* webpackChunkName: "getting-started-automation" */ './containers/LearnAutomationContainer');
const importManualTestingRoutes = () => import(/* webpackChunkName: "getting-started-manual" */ './containers/ManualTestingContainer');
const importIntegrateTestsRoutes = () => import(/* webpackChunkName: "getting-started-manual" */ './containers/IntegrateTestsContainer');

const GettingStartedRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.WEB_PLATFORM}>
      <Switch>
        <BundleRoute
          load={importLearnAutomationRoutes}
          path={`${match.url}/learn-automation`}
        />
        <BundleRoute
          load={importManualTestingRoutes}
          path={`${match.url}/manual-testing`}
        />
        <BundleRoute
          load={importIntegrateTestsRoutes}
          path={`${match.url}/automated-testing`}
        />
        <BundleRoute
          load={importGettingStartedRoutes}
          path={match.url}
        />
      </Switch>
    </SentryBoundary>
  </LoginRequiredContainer>
);

GettingStartedRoutes.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
};

export default GettingStartedRoutes;
